import React, { Component } from 'react'

import { withTheme } from 'styled-components'

import DatatableComponent from './Datatable.component'

import { generateUUID } from './utils/strings'
import Environment from './utils/environment'
import Analytics from './utils/analytics'

import API from './api/API'

class DatatableContainer extends Component {
  constructor(props) {
    super(props)

    const width = props.component_config.headers.reduce((acc, curr) => {
      // note: additional 40px added to account for horizontal padding on right-ward boundary
      // TODO: this should be dynamic
      return acc + (curr.width + 40)
    }, 0)

    this.state = {
      tableId: props.table_id,
      serverRequestInFlight: false,
      filterDrawerOpen: false,
      exportDialogOpen: false,
      searchDialogOpen: false,
      datasetWidth: null,
      scrollOffset: 0,
      headers: props.component_config.headers,
      multiLineRow: props.component_config.multiLineRow,
      width,
      selectedRows: [],
      data: null,
      freezeCol: this.getConfigOption(props.component_config, 'freezeLeftCol'),
      title: props.title || '',
      multiselect: this.getConfigOption(props.component_config, 'multiselect'),
      subRows: this.getConfigOption(props.component_config, 'subRows'),
      rowActions: this.getConfigOption(props.component_config, 'rowActions'),
      rowFlag: this.getConfigOption(props.component_config, 'rowFlag'),
      pagination: this.getConfigOption(props.component_config, 'pagination'),
      savedFilters: this.getConfigOption(props.component_config, 'savedFilters'),
      quickFilters: this.getConfigArray(props.component_config, 'quickFilters'),
      extraFilters: this.getConfigOption(props.component_config, 'extraFilters'),
      download: this.getConfigOption(props.component_config, 'download'),
      headerButtons: this.getConfigOption(props.component_config, 'headerButtons'),
      i18n: this.geti18n(props),
      saveFilterError: null
    }

    if (this.state.quickFilters && this.state.quickFilters.length > 0) {
      this.state.quickFilters = this.state.quickFilters.map((quickFilter) => {
        quickFilter.uuid = generateUUID()
        return quickFilter
      })
    }

    // set a sensible default width for actions cell if none present
    if(this.state.rowActions && !this.state.rowActions.width) {
      this.state.rowActions.width = 232;
    }

    const path = (props.callbackPath) ? props.callbackPath : 'TR_pageFunctions'

    this.env = new Environment(path)
    this.api = new API(this.env)

    let pageSize = 10

    if (this.state.pagination && this.state.pagination.pageSize) {
      pageSize = this.state.pagination.pageSize
    }

    this.postLoadCallback = this.getConfigOption(props.component_config, 'postLoadCallback')

    this.api.setupAPI({
      sortEngine: (props.sortEngine) ? props.sortEngine : 'client',
      endpointParams: (props.endpointParams) ? props.endpointParams : {},
      endpoint: props.endpoint,
      postLoadCallback: this.postLoadCallback || {callback: 'postLoadCallback'},
      basicPaginationEnabled: this.state.pagination && this.state.pagination.basicPaginationEnabled ? this.state.pagination.basicPaginationEnabled : false,
      pageSize
    })

    const propagationHandler = props.analyticsPropagationHandler || (() => {})

    this.analytics = new Analytics('MyRefinitiv_AEM', window.digitalData || {}, props.title || 'default', propagationHandler, this.api)
  }

  geti18n(props) {
    if (props.i18n) {
      return props.i18n
    }

    return {
      'selectRange': 'Select range',
      'selectFileFormat': 'Select a file format',
      'filter': 'Filter',
      'download': 'Download',
      'downloadConfirm': 'Download exceeds limit',
      'downloadConfirmMessage': 'You have requested to download more than 15000 records. You can click "Continue" to start download or "Cancel" to refine your download request.',
      'apply': 'Apply',
      'cancel': 'Cancel',
      'next': 'Next',
      'continue': 'Continue',
      'previous': 'Prev',
      'quickFilters': 'Quick filters',
      'savedFilters': 'Saved filters',
      'columnFilters': 'Column filters',
      'applyFilter': 'Apply filters',
      'saveFilters': 'Save filters',
      'clearAll': 'Clear all',
      'saveFilter': 'Save Filter',
      'pleaseName': 'Please name this filter to save',
      'name': 'Name',
      'save': 'Save',
      'continueWithoutSaving': 'Continue without saving',
      'noSavedFilters': 'No saved filters',
      'noResultsFilters': 'There are 0 results for the filters applied, ',
      'clearFilters': 'clear filters',
      'andTryAgain': ' and try again.',
      'noResults': 'No results',
      'search': 'Search',
      'extraFilters': 'Extra Filters',
      select_from_date: 'from',
      select_to_date: 'to',
      invalid_from_date: 'Please enter a valid date',
      invalid_to_date: 'Please enter a valid date',
      invalid_date_range: 'Please enter a valid from date range',
      invalid_from_future_date: 'Future date is not allowed',
      invalid_to_future_date: 'Future date is not allowed',
      invalid_date: 'Please enter a valid date',
      invalid_future_date: 'Future date is not allowed',
      saveFilterErrorMsg: "Please try again later or contact us",
      saveFilterCloseBtnText: "Close"
    }
  }

  /**
   * @param {Object} configObject
   * @param {String} option
   *
   * @description extract config option from object
   */
  getConfigOption(configObject, option) {
    if (configObject[option] && configObject[option].enabled) {
      return configObject[option]
    }

    return null
  }

  /**
   * @param {Object} configObject
   * @param {String} option
   *
   * @description extract config array from object
   */
  getConfigArray(configObject, option) {
    if (configObject[option] && configObject[option].length > 0) {
      return configObject[option]
    }

    return []
  }

  /**
   * @param {String} column
   *
   * @description get a readable name for a column from somewhere/anywhere in the config
   */
  getNameFromColumn(column) {
    let output = null

    this.state.headers.map((header) => {
      if (header.datafield === column) {
        output = header.title
      }
    })

    if (output) {
      return output
    }

    if (this.state.extraFilters && this.state.extraFilters.filters.length > 0) {
      this.state.extraFilters.filters.map((extraFilter) => {
        if (extraFilter.column === column) {
          output = extraFilter.title
        }
      })
    }

    if (output) {
      return output
    }

    return column
  }

  /**
   * @param {Int} scrollOffset
   *
   * @description Set pixel distance offset on left-ward boundary to handle scrolling
   */
  setOffset = (scrollOffset) => {
    this.setState({
      scrollOffset
    })
  }

  /**
   * @description Get width of wrapping container
   */
  calculateDatasetWidth() {
    return this.wrapper.offsetWidth
  }

  /**
   * @param {Object} response
   *
   * @description Callback handler for retrieving data from API
   */
  updateDataset = (response) => {
    this.hideServerSpinner()

    if (response.error) {
      this.setState({
        error: response.error
      })
    } else {
      this.setState({
        data: response,
        error: null,
        datasetWidth: this.calculateDatasetWidth()
      })
    }
  }

  /**
   * @param {Object} response
   *
   * @description Callback handler for retrieving saved filters from localStorage or API
   */
  updateSavedFilters = (response) => {
    if (response.error) {
      this.setState({
        saveFilterError: response.error
      })
    } else {
      this.setState({
        savedFilters: response,
        saveFilterError: null
      })
    }
  }

  /**
   * @description - reset pagination to page 1. Important to use after any filter/sort/search is applied
   */
  resetPagination() {
    const pagination = this.api.getPagination()

    pagination.offset = 1
    this.api.setPaginationButtonClicked()
    this.api.setPagination(pagination)
  }

  /**
   *
   * @param {Object} sortObject
   *
   * @description Send sort object to API and trigger re-render
   */
  handleSort = (sortObject) => {
    this.resetPagination()
    this.api.setSort(sortObject)

    this.showServerSpinner()

    this.analytics.filterContent(this.api.getFiltersAsList(), this.api.getSort(), this.api.getPagination(), this.api.getCustomFilterObj())

    this.api.getDataSet(this.updateDataset, false)

    return true
  }

  /**
   * @param {Object} filterObject
   *
   * @description Send filter object to API and trigger re-render
   */
  handleFilter = (filterObject, skipAnalytics) => {
    this.api.clearFilters()
    this.resetPagination()
    this.api.setSelectedRows([])
    this.setState({
      selectedRows: []
    })

    Object.keys(filterObject).forEach((key) => {
      // DEVNOTE: this is a necessary evil. We cannot be sure that a filter object will contain a title
      // if it comes from a previously applied quick or saved filter which has been overridden by a change to the filter array
      // the filter will not contain one because it would have been previously assumed this was of value "custom".
      // The below statement ensures that we always push a name onto a filter if it is possible to get one from somewhere/anywhere
      if (!filterObject[key].title) {
        filterObject[key].title = this.getNameFromColumn(filterObject[key].column)
      }
      this.api.setFilter(filterObject[key])
    })

    this.showServerSpinner()

    if (!skipAnalytics) {
      this.analytics.filterContent(this.api.getFiltersAsList(), this.api.getSort(), this.api.getPagination(), this.api.getCustomFilterObj())
    }

    this.api.getDataSet(this.updateDataset, false)

    return true
  }

  /**
   * @param {Object} single filter object
   *
   * @description remove a single filter and trigger re-render
   */
  handleRemoveFilter = (filterObj) => {
    const filterState = this.api.getFilters()

    this.resetPagination()

    delete filterState[filterObj.handle]

    Object.keys(filterState).forEach((key) => {
      this.api.setFilter(filterState[key])
    })

    this.showServerSpinner()

    this.analytics.filterContent(this.api.getFiltersAsList(), this.api.getSort(), this.api.getPagination(), this.api.getCustomFilterObj())

    this.api.getDataSet(this.updateDataset, false)

    return true
  }

  setSearch = (searchValue) => {
    this.resetPagination()
    this.api.setSearch(searchValue)

    this.analytics.filterContent(this.api.getFiltersAsList(), this.api.getSort(), this.api.getPagination(), this.api.getCustomFilterObj(), this.api.getSearch())
    this.api.getDataSet(this.updateDataset, false)

    return true
  }

  unsetSearch = () => {
    this.resetPagination()
    this.api.unsetSearch()

    this.analytics.filterContent(this.api.getFiltersAsList(), this.api.getSort(), this.api.getPagination(), this.api.getCustomFilterObj(), this.api.getSearch())
    this.api.getDataSet(this.updateDataset, false)

    return true
  }

  handleSaveFilters = () => {
    this.setState({
      saveFilterDialogOpen: true
    })
  }

  handleSaveDialogClose = () => {
    this.setState({
      saveFilterDialogOpen: false,
      saveFilterError: null
    })
  }

  handleSave = (filterName) => {
    const { savedFilters, tableId } = this.state

    if (savedFilters && tableId) {
      this.api.addSavedFilter(savedFilters, tableId, filterName, this.updateSavedFilters)
    }
  }

  handleRemove = (filterID) => {
    const { savedFilters, tableId } = this.state

    if (savedFilters && tableId && filterID) {
      this.api.removeSavedFilter(savedFilters, tableId, filterID, this.updateSavedFilters)
    }
  }

  /**
   *
   * // TODO Check if we are using this function anywhere
   * @param {String} direction
   *
   * @description Paginate up/down and trigger re-render
   */
  handlePaginationJump = (direction) => {
    let jump = this.api.getPagination().offset

    if (direction === 'UP') {
      jump = jump + 1
    }

    if (direction === 'DOWN') {
      jump = jump - 1
    }

    this.handlePaginationSeek(jump)
  }

  /**
   *
   * @param {Int} position
   *
   * @description Paginate to specific page view and trigger re-render
   */
  handlePaginationSeek = (position, buttonClicked) => {
    this.api.setPaginationButtonClicked(buttonClicked)
    const pagination = Object.assign({}, this.api.getPagination())

    const modulo = this.api.getTotalItems() % pagination.pagesize
    let totalPages = (this.api.getTotalItems() - (this.api.getTotalItems() % pagination.pagesize)) / pagination.pagesize

    if (modulo > 0) {
      totalPages += 1
    }

    if (position > totalPages || position < 1) {
      return false
    }

    const lastPosition = pagination.offset

    pagination.offset = position

    if (this.api.basicPaginationEnabled && (((lastPosition === totalPages) && (position === 1)) || ((position === totalPages) && (lastPosition === 1)))) {
      this.showServerSpinner()
      this.api.setPagination(pagination)
      if (totalPages === 1) {
        this.api.setDataSet()
        this.api.getDataSet(this.updateDataset, false, buttonClicked === 'prev' ? 'loadPrevTable' : 'loadNextTable')
      } else if (totalPages === 2) {
        if (position === 1 && buttonClicked === 'next') {
          this.api.setDataSet()
          this.api.getDataSet(this.updateDataset, false, 'loadNextTable')
        } else if (position === totalPages && buttonClicked === 'prev') {
          this.api.setDataSet()
          this.api.getDataSet(this.updateDataset, false, 'loadPrevTable')
        } else {
          this.api.getDataSet(this.updateDataset, true)
        }
      } else {
        this.api.setDataSet()
        this.api.getDataSet(this.updateDataset, false, lastPosition === 1 ? 'loadPrevTable' : 'loadNextTable')
      }
    } else {
      this.showServerSpinner()
      this.api.setPagination(pagination)
      this.api.getDataSet(this.updateDataset, true)
    }


    this.analytics.propagateEvent({
      eventType: 'click',
      action: 'Pagination click',
      type: 'Data Table'
    })
  }

  /**
   * @description Event handler for filter drawer open/close
   */
  handleFilterOpen = () => {
    this.setState({
      filterDrawerOpen: !this.state.filterDrawerOpen
    })

    this.analytics.propagateEvent({
      eventType: 'click',
      action: 'Filter tray button click',
      type: 'Data Table'
    })
  }

  closeFilterOnExportClick = () => {
    this.setState({
      filterDrawerOpen: false
    })
  }

  /**
   * @description Event handler for search dialog open/close
   */
  handleSearchOpen = () => {
    this.setState({
      searchDialogOpen: !this.state.searchDialogOpen
    })
  }

  /**
   * @description Event handler for export dialog open/close
   */
  handleExportDialogOpen = () => {
    this.setState({
      exportDialogOpen: !this.state.exportDialogOpen
    })
  }

  /**
   * @description Event handler for global window resize
   */
  handleWindowResize = () => {
    this.setState({
      datasetWidth: this.calculateDatasetWidth()
    })
  }

  /**
   *
   * @param {Boolean} mobile
   *
   * @description Event handler for responsive reflow
   */
  handleMobileSwitch = (mobile) => {
    this.setState({
      mobile
    })
  }

  /**
   * show global spinner if server request in flight
   */
  showServerSpinner() {
    if (this.props.sortEngine === 'server') {
      this.setState({
        serverRequestInFlight: true
      })
    }
  }

  /**
   * hide global spinner when server request complete
   */
  hideServerSpinner() {
    if (this.props.sortEngine === 'server') {
      this.setState({
        serverRequestInFlight: false
      })
    }
  }

  setSelectedRows = (selectedRows, selectAll=false) => {
    this.api.setSelectedRows(selectedRows, selectAll)
    this.setState({
      selectedRows
    })
  }

  checkAndLoadSavedFilter() {
    const { savedFilters, tableId } = this.state

    const isEnabled = savedFilters && savedFilters.enabled
    const hasEndpoint = savedFilters && savedFilters.endpoint && savedFilters.endpoint.length > 0

    if (tableId && isEnabled && hasEndpoint) {
      this.api.getSavedFilters(savedFilters, tableId, this.updateSavedFilters)
    }
  }

  checkAndApplyDefaultFilter() {
    let checkedFilter = null

    if (this.state.quickFilters) {
      this.state.quickFilters.map((quickFilter) => {
        if (quickFilter.default) {
          checkedFilter = quickFilter
        }
      })
    }

    if (checkedFilter) {
      const filtersToApply = {}

      const formatQuickDate = (str) => {
        return str.substr(0, 4) + '-' + str.substr(4, 2) + '-' + str.substr(6) + 'T00:00:00.000Z'
      }

      const yieldFilterItem = (filterType) => {
        if (filterType === 'list' || filterType === 'select') {
          return 'select'
        }

        if (filterType === 'daterange') {
          return 'daterange'
        }

        if (filterType === 'search') {
          return 'text'
        }

        if (filterType === 'dateselector') {
          return 'dateselector'
        }
        
        return filterType
      }

      checkedFilter.content.map((filterItem) => {
        const handle = 'bodyfilter_' + yieldFilterItem(filterItem.type) + '_' + filterItem.column

        if (filterItem.type === 'daterange') {
          if (typeof filterItem.values === 'string' && filterItem.values.indexOf(';') > -1) {
            const rawValues = filterItem.values.split(';')

            const obj = {
              startDate: new Date(formatQuickDate(rawValues[0])),
              endDate: new Date(formatQuickDate(rawValues[1]))
            }

            filterItem.values = obj
          }
        }

        if (filterItem.values !== null && typeof filterItem.values === 'string' && filterItem.type === 'dateselector') {
          let obj = {}

          if (filterItem.values.indexOf(';') > -1) {
            const rawValues = filterItem.values.split(';')

            if (rawValues[0] === 'datesingle') {
              if (rawValues[1] === 'today') {
                obj = {
                  dateType: 'dateSingle',
                  selectedId: 'today'
                }
              } else {
                obj = {
                  dateType: 'dateSingle',
                  selectedId: 'dateSingle',
                  date: new Date(formatQuickDate(rawValues[1]))
                }
              }
            } else if (rawValues[0] === 'daterange') {
              if (rawValues[1] === '7') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: '7'
                }
              } else if (rawValues[1] === '30') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: '30'
                }
              } else if (rawValues[1] === 'week') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'week'
                }
              } else if (rawValues[1] === 'month') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'month'
                }
              } else {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'dateRange',
                  startDate: new Date(formatQuickDate(rawValues[1])),
                  endDate: new Date(formatQuickDate(rawValues[2]))
                }
              }
            } else {
              obj = {
                dateType: 'dateRange',
                selectedId: 'dateRange',
                startDate: new Date(formatQuickDate(rawValues[0])),
                endDate: new Date(formatQuickDate(rawValues[1]))
              }
            }
          } else {
            obj = {
              dateType: 'dateSingle',
              selectedId: 'dateSingle',
              date: new Date(formatQuickDate(filterItem.values))
            }
          }
          filterItem.values = obj
        }

        if (filterItem.type === 'list' || filterItem.type === 'select' || filterItem.type === 'treeView') {
          if (typeof filterItem.values === 'string' && filterItem.values.indexOf(';') > -1) {
            if (typeof filterItem.values === 'string' && filterItem.values.indexOf(';') > -1) {
              const rawValues = filterItem.values.split(';')
              const obj = rawValues.map((item) => {
                return {
                  label: item,
                  value: item
                }
              })

              filterItem.values = obj
            }
          }
        }

        filterItem.handle = handle
        filtersToApply[handle] = filterItem
      })

      this.api.setCustomFilterId(checkedFilter.uuid)
      this.api.setCustomFilter(checkedFilter.title)
      this.api.setCustomFilterType('quick')
      this.handleFilter(filtersToApply, true)

      this.analytics.defaultFilterContent(this.api.getFiltersAsList());
    }

    return checkedFilter
  }

  componentDidMount() { 
    window.addEventListener('resize', this.handleWindowResize )
    
    const defaultFilter = this.checkAndApplyDefaultFilter()

    if (!defaultFilter) {
      this.api.getDataSet(this.updateDataset)
    }

    this.checkAndLoadSavedFilter()
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleWindowResize)
  }

  render() {
    const { width, mobile, i18n } = this.state
    let { freezeCol } = this.state

    // DEVNOTE: some state juggling to work out whether we should freeze left col or not, depending on width of window.
    if (freezeCol && this.state.datasetWidth && (this.state.datasetWidth > width)) {
      freezeCol = false
    }

    // force freezecol under all circumstances for mobile.
    if (mobile) {
      freezeCol = true
    }

    const customFilter = this.api.getCustomFilter()

    return (
      <div className='' ref={(wrapper) => { this.wrapper = wrapper }}>
        <DatatableComponent
          titleFormatter={this.getConfigOption(this.props.component_config, 'titleFormatter')}
          setSelectedRows={this.setSelectedRows}
          freezeCol={freezeCol}
          i18n={i18n}
          analytics={this.analytics}
          api={this.api}
          env={this.env}
          setSearch={this.setSearch}
          unsetSearch={this.unsetSearch}
          handleExportDialogOpen={this.handleExportDialogOpen}
          handleSearchDialogOpen={this.handleSearchDialogOpen}
          state={this.state}
          handleSaveFilters={this.handleSaveFilters}
          handleFilterOpen={this.handleFilterOpen}
          closeFilterOnExportClick={this.closeFilterOnExportClick}
          handleFilter={this.handleFilter}
          savedFilters={this.state.savedFilters}
          handleSort={this.handleSort}
          handleRemoveFilter={this.handleRemoveFilter}
          appliedFilters={this.api.getFilters()}
          customFilter={customFilter}
          sort={this.api.getSort()}
          gridWidth={width}
          setOffset={this.setOffset}
          handleMobileSwitch={this.handleMobileSwitch}
          handlePaginationJump={this.handlePaginationJump}
          handlePaginationSeek={this.handlePaginationSeek}
          error={this.state.error}
          errorHandling={this.props.errorHandling}
          containerRef={this.wrapper}
          onSaveClose={this.handleSaveDialogClose}
          onSearchClose={this.handleSearchOpen}
          handleSave={this.handleSave}
          handleSearch={this.setSearch}
          handleRemove={this.handleRemove}
          onExportClose={this.handleExportDialogOpen}
          download={this.state.download}
          filters={this.api.getFiltersAsList()}
          props={this.props}
          wrapper={this.wrapper}
          selectedRows={this.state.selectedRows}
          saveFilterError={this.state.saveFilterError}
        />
      </div>
    )
  }
}

export default withTheme(DatatableContainer)
export { DatatableContainer as DatatableContainerBase }
